<template lang="pug">
  .component-reservation-controller(v-if="logs")
    statistics-card4
      dl(v-if="bookedTimes" slot="n1")
        dt Start:
        dd {{$dateFormat(bookedTimes.final_start, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
        dt Booked Start:
        dd {{$dateFormat(item.start, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
        dt Minimum booked start:
        dd {{$dateFormat(bookedTimes.minimum_booked_start, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
        dt Actual Start:
        dd {{$dateFormat(bookedTimes.actual_start, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
      dl(v-else slot="n1")
        dt Booked Start:
        dd {{$dateFormat(item.start, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
      dl(v-if="bookedTimes" slot="n2")
        dt End:
        dd {{$dateFormat(bookedTimes.final_end, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
        dt Booked End:
        dd {{$dateFormat(bookedTimes.booked_end, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
        dt Maximum booked end:
        dd {{$dateFormat(bookedTimes.maximum_booked_end, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
        dt Actual End:
        dd {{$dateFormat(bookedTimes.actual_end, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
      dl(v-else slot="n2")
        dt Booked End:
        dd {{$dateFormat(item.end, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}

      dl(slot="n3" v-if="bookedTimes")
        dt Initial duration:
        dd {{bookedTimes.human_total_booked}}

        dt Total duration:
        dd {{bookedTimes.human_total_booked_final}}

        dt Billable End:
        dd {{$dateFormat(bookedTimes.billable_end, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}

        dt Billing status:
        dd {{item.billing_status}}
        dt(v-if="item.billing_status === 'UNCHARGEABLE'") Cancelled: {{item.canceled}}
        template(v-if="item.memo !== null")
          dt Memo
          dd {{item.memo}}
      div(slot="n4")
        dl
          dt Total driven distance:
          dd {{item.distance}}{{configuration.locale.locale_distance_unit.value}}
        hr
        ReservationFlag(:reservation="item")
    // Cards(:data="cardData")
    .row
      .columns.large-6.small-12
        .card
          driver(:type="'driver-card'", :item="item.driver")
        vehicle(:type="'compact-card'", :item="vehicle")
          vehicle-additional-status(:item="vehicle")
          h2 {{item.booking_mode}}

        tab-headers(:tabs="tabs", :id="'reservation-detail'", :activeIndex="0")

          tab-content(:headerName="'Billing & Costs'", :active="true")
            .row.columns
              template(v-if="item.reservation_rate" )
                h4.text-center
                  span RR{{item.reservation_rate.id}} {{item.reservation_rate.name}}
                .row.text-center
                  .columns
                    .field-cost-per-time
                      .field-label Cost per Time
                        div(v-if ="Array.isArray(item.reservation_rate.config.time_config)")
                          h3.mb-0
                            strong {{$priceWithcurrency(item.reservation_rate.time_rate.time_cost)}} / {{parseMinutes(item.reservation_rate.time_rate.time_cost_cycle)}}
                          div( v-for="time in timeConfig")
                            small {{time}}
                        div(v-else)
                          h3.mb-0
                            strong {{$priceWithcurrency(item.reservation_rate.time_rate.time_cost)}} / {{parseMinutes(item.reservation_rate.time_rate.time_cost_cycle)}}
                          small {{item.reservation_rate.time_rate.name}}
                  .columns
                    .field-cost-per-distance
                      .field-label Cost Per distance
                        h3.mb-0
                          strong {{distanceConfig[0]}}
                        div(v-for="distance in distanceConfig" )
                          small {{distance}}

                  .columns
                    .field-other-costs Other costs
                      .field-label
                        h3
                          strong {{getOtherCosts()}}

              accordion(:titles="accordionData", multiExpand="true")
                div(slot="Cost breakdown")
                  table
                    thead
                      th(v-for="head in ['Id','Description','Amount']") {{head}}
                    tbody
                      tr(v-if="debugInfo.overhead")
                        td(v-if="debugInfo.overhead") {{debugInfo.overhead.id}}
                        td(v-if="debugInfo.overhead") Reservation overhead
                        td(v-if="debugInfo.overhead") {{getOverHeadCost()}}
                      tr(v-if="debugInfo.overtime")
                        td(v-if="debugInfo.overtime") {{debugInfo.overtime.id}}
                        td(v-if="debugInfo.overtime") Reservation overtime
                        td(v-if="debugInfo.overtime") {{getOverTimeCost()}}
                      tr(v-if="debugInfo.calculated_cost")
                        td(v-if="debugInfo.calculated_cost") {{debugInfo.calculated_cost.id}}
                        td(v-if="debugInfo.calculated_cost") Reservation R{{item.number}}
                        td(v-if="debugInfo.calculated_cost") {{currency}}{{debugInfo.calculated_cost.total_cost}}

                div(slot="Applied Rates & Overrides")
                  applied-rates(v-if="debugInfo", :item="getAppliedRates()")
                div(slot="Deposits")
                  table
                    thead
                      th(v-for="head in ['Id','Description','Status','Amount','Date']") {{head}}
                    tr.deposits(v-for="deposit in deposits")

                      td {{deposit.id}}
                      td
                        span {{deposit.reason}}
                      td {{deposit.status}}
                      td {{$priceWithcurrency(deposit.amount)}}
                      td  {{$dateFormat(deposit.created_at, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
                div(slot="Preauths")
                  PreauthList(:reservation="item")
              hr
              div(v-if="item.cost") Total
                span.float-right
                  h2 {{currency}}{{item.cost}}
                  .help-text vat included
          tab-content(:headerName="'Trips Data'")

            ul.accordion(data-accordion='', data-allow-all-closed='true', v-f-accordion="")
              li.accordion-item(data-accordion-item='' v-for="trip in item.trips")
                a.accordion-title(href='#') Trip {{trip.id}}
                .accordion-content(data-tab-content='')
                  table
                    thead
                      th(v-for="head in ['Id','Start','End','Distance','Speed']") {{head}}
                    tbody
                      tr
                        td {{trip.id}}
                        td {{$dateFormat(trip.start, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
                        td {{$dateFormat(trip.end, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
                        td {{trip.distance}} {{configuration.locale.locale_distance_unit.value}}
                        td {{trip.speed}} {{configuration.locale.locale_distance_unit.value}}/h

          tab-content(headerName="Notes")
            ReservationNotes
          tab-content(:headerName="'Reports'")
            .component-tabbed-vehicle-costs
              template(v-if="!item.reportings.length" )
                h2.text-center nothing to show
              reporting(v-else, v-for="reporting in item.reportings", :item="reporting", type="reservation")
              //pre {{item.reportings}}
          tab-content(v-if="item.booking_mode==='STR'" headerName="STR Detail")
            .row.columns(v-if="item.segment_rate!=null")
              accordion(:titles="segmentData", multiExpand="true")
                div(slot="Segment")
                  .row
                    .columns
                      .field-segment-id
                        .field-label id
                          p
                            strong {{item.segment_rate.segment.id}}
                    .columns
                      .field-segment-name
                        .field-label Name
                          p
                            strong {{item.segment_rate.segment.name}}
                    .columns
                      .field-segment-description
                        .field-label Description
                          p
                            strong {{item.segment_rate.segment.description}}
                div(slot="Rental agreement")
                  p(v-html="item.segment_rate.extended_description")
            .row.columns(v-else)
              h2.no-result-message.text-center Nothing to show here yet :(
          tab-content(headerName="Charging sessions")
            ChargingSessionsList(:reservation="item")
      .columns.small-12.large-6
        .card
          .inner-content
            BackofficeReservation(:item="item", type="start-end-position")

        .card(v-if="$acl('route-reservation')")
          .inner-content
            ReservationRoute(v-if="item", :item="item")
        .card
          .inner-content
            .row
              .column
                span Reservation Status
                h2 {{item.status}}
              .column
                span Commercial Status
                h2 {{item.billing_status}}

            reservation-log-time-line(:items="logs")
</template>
<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import MaggieHelper from 'src/maggieHelper'
import Accordion from 'components/structure/foundation/Accordion.vue'
import DatePicker from 'components/structure/DatePicker'
import Dropdown from 'components/structure/foundation/Dropdown'
import Card9 from 'components/structure/Card9'
import ReservationActionButtons from 'components/structure/ui/actions/ReservationActionButtons'
import Driver from 'components/backoffice/Driver'
import Vehicle from 'components/backoffice/Vehicle'
import StatisticsCard4 from 'components/structure/ui/StatisticsCard4'
import TabHeaders from 'components/structure/foundation/TabHeaders'
import TabContent from 'components/structure/foundation/TabContent'
import AppliedRates from '../../../components/backoffice/AppliedRates'
import ReservationLogTimeLine from '../../../components/backoffice/ReservationLogTimeLine.vue'
import ModalReveal from '../../../components/structure/foundation/ModalReveal.vue'
import ReservationNotes from '../../../components/backoffice/tabbed/ReservationNotes'
import {mapState} from 'vuex'
import ReservationRoute from '../ReservationRoute'
import BackofficeReservation from '../../../components/backoffice/Reservation'
import Cards from '../../../components/structure/Cards'
import ActionButton from '../../../components/structure/ui/ActionButton'
import StatisticsCard5 from '../../../components/structure/ui/StatisticsCard5'
import SelectizeCommonCost from '../../../components/structure/ui/lists/selectize/SelectizeCommonCost'
import ReservationFlag from '../../../components/backoffice/ReservationFlag'
import Reporting from "../../../components/backoffice/Reporting.vue";
import VehicleAdditionalStatus from "../../../components/structure/ui/VehicleAdditionalStatus.vue";
import ChargingSessionsList from "../ChargingSessionsList.vue";
import PreauthList from "../PreauthList.vue";


export default {
  name: 'ReservationController',
  components: {
    PreauthList,
    ChargingSessionsList,
    VehicleAdditionalStatus,
    Reporting,
    ReservationFlag,
    SelectizeCommonCost,
    StatisticsCard5,
    ActionButton,
    Cards,
    BackofficeReservation,
    ReservationRoute,
    ReservationNotes,
    ModalReveal,
    ReservationLogTimeLine,
    AppliedRates,
    TabContent,
    TabHeaders,
    StatisticsCard4,
    Accordion,
    DatePicker,
    Dropdown,
    Card9,
    ReservationActionButtons,
    Driver,
    Vehicle
  },
  data() {
    return {
      debugInfo: null,
      accordionData: {
        'Cost breakdown': 'Cost breakdown',
        'Applied Rates & Overrides': 'Applied Rates & Overrides',
        'Deposits': 'Deposits',
        'Preauths': 'Preauths',
      },
      segmentData: {
        'Segment': 'Segment',
        'Rental agreement': 'Rental agreement',
      },
      extendTime: null,
      logs: null,
      deposits: [],
      bookedTimes: null,
      tabs: []
    }
  },
  created() {
    KeplerBackofficeSdk.reservations.select(this.item).debugInfo((data) => {
      this.debugInfo = data
      this.logs = data.logs
    })


    KeplerBackofficeSdk.reservations.select(this.item).deposits((data) => {
      this.deposits = data
    })

    KeplerBackofficeSdk.reservations.select(this.item).bookedTimes((data) => {
      this.bookedTimes = data
    })
  },
  mounted() {
    this.getTabHeaders()
  },
  methods: {
    getTabHeaders() {
      this.tabs = ['Billing & Costs', 'Trips Data', 'Notes', 'Reports', 'Charging sessions']
      if (this.item.booking_mode === 'STR') {
        this.tabs.push('STR Detail')
      }
      return this.tabs
    },
    getDistanceCost() {
      var calculatedCosts = this.debugInfo.calculated_cost
      return calculatedCosts ? this.currency + calculatedCosts.distance_cost : '-'
    },
    getTimeCost() {
      var calculatedCosts = this.debugInfo.calculated_cost
      return calculatedCosts ? this.currency + calculatedCosts.time_cost : '-'
    },
    getAppliedRates() {
      var calculatedCosts = this.debugInfo.calculated_cost
      return calculatedCosts ? this.debugInfo.calculated_cost : []
    },

    getOverTimeCost() {
      var overtimeCost = this.debugInfo.overtime

      return overtimeCost ? this.currency + overtimeCost.amount : '-'
    },
    getOverHeadCost() {
      var overHeadCost = this.debugInfo.overhead
      return overHeadCost ? this.currency + overHeadCost.amount : '-'
    },

    getOtherCosts() {
      var overtimeCost = this.debugInfo.overtime ? this.debugInfo.overtime.amount : 0
      var overHeadCost = this.debugInfo.overhead ? this.debugInfo.overhead.amount : 0

      var total = (overtimeCost + overHeadCost)
      return !isNaN(parseFloat(total)) && isFinite(total) ? this.currency + total : '-'
    },
    extend: function () {
      KeplerBackofficeSdk.reservations.select(this.item.number).extend(this.convertTimestamp(this.extendTime), (response) => {
        MaggieHelper.notification('extend-esit', 'reservation extended')
      })
    },
    convertTimestamp: function (datetime) {
      var t = datetime.split(/[- :]/)
      var date = new Date(t[0], t[1] - 1, t[2], t[3], t[4])
      return Math.round(date.getTime() / 1000)
    },
    handleExtend: function (timestamp) {
      this.extendTime = timestamp
      this.extend()
    },
    parseMinutes(val) {
      if (val < 1440) {
        switch (val) {
          case 1:
            return 'minute'
          case 60:
            return 'hour'
          default:
            if (!(val % 60)) {
              return `hours ${val / 60}`
            } else {
              return `minutes ${val}`
            }
        }
      } else {
        const d = val / 1440
        switch (d) {
          case 1:
            return 'day'
          case 7:
            return 'week'
          case 30:
            return 'month'
          case 60:
            return 'two months'
          case 90:
            return 'three months'
          case 365:
            return 'year'
          default:
            if (!(d % 30)) {
              return `months ${d / 60}`
            } else if (!(d % 7)) {
              return `weeks ${d / 7}`
            } else {
              return `days ${d}`
            }
        }
      }
    }
  },
  computed: {
    distanceConfig() {
      let distance = []
      const distanceConfig = this.item.reservation_rate.config.distance_config.reverse()
      distance = distanceConfig.map((config) => {
        let conf = config.split(" ")
        const distanceUnit = this.configuration.locale.locale_distance_unit.value
        const distance = `${conf[0]}${distanceUnit}`
        let cost = conf[1].split('|')

        return `${distance} - ${cost[0]}€/${cost[1]}${distanceUnit}`
      })

      return distance
    },
    timeConfig() {
      let times = []
      const timeConfig = this.item.reservation_rate.config.time_config.reverse()
      times = timeConfig.map((time) => {
        let timesArray = time.split("|")
        let timesRateToSplit = timesArray[0].split(" ")
        let timeAndCost = timesRateToSplit[0] + "min -" + timesRateToSplit[1] + "" + this.configuration.commercial.commercial_currency.value
        let perTime = timesArray[1] + "" + this.parseMinutes(1)

        return `${timeAndCost}/${perTime}`

      })
      return times
    },
    vehicle() {
      return this.item.vehicle
    },
    ...mapState({
      configuration: state => state.configuration,
    }),
    currency() {
      return this.configuration.commercial.commercial_currency.value
    },
    cardData() {
      const dateFormat = this.configuration.locale.locale_datetime_format.value

      let extendComponent = null
      const callback = {}

      if (this.item.status !== 'COMPLETED' && this.item.booking_mode === 'RT') {
        extendComponent = () => {
          MaggieHelper.openTopPanel({
            component: require('components/backoffice/extend-reservation/TimeRangeWrapper.vue'),
            props: {
              reservation: this.item,
            }
          })
        }

        callback.func = extendComponent
        callback.class = 'fa fa-arrow-right'

      }
      return [
        {
          title: 'Start',
          value: this.$dateFormat(this.item.start, this.$toMomentFormat(dateFormat)),
          color: '#5EB9CF',

        },
        {
          title: 'End',
          value: this.$dateFormat(this.item.end, this.$toMomentFormat(dateFormat)),
          color: '#5EB9CF',
          //callback: callback
        },
        {
          title: 'Total duration',
          value: this.$dateDifference(this.item.start, this.item.end),
          color: '#5EB9CF'
        },
        {
          title: 'Total driven distance',
          value: `${Math.round(this.item.distance)}${this.configuration.locale.locale_distance_unit.value}`,
          color: '#5EB9CF'
        },
      ]
    }
  },
  props: ['item'],

}
</script>
<style lang="sass" rel="stylesheet/sass">
.component-reservation-controller
  tr.deposits
    span
      display: block

  .card-section
    h1
      font-size: 1.6em

  .component-statistics-card
    dt
      margin-bottom: 0

    dd
      font-size: 1.25rem
      line-height: 1
      margin-bottom: 0.5rem
      color: #5EB9CF
</style>



// WEBPACK FOOTER //
// Reservation.vue?684d3e8f